import { ProgressTrack } from "../LoadingBar/ProgressTrack";

export const DashboardBanner = ({ fups = {}, currPeriod, fupEnabled, isPsb }) => {
    // const isFupExits = !!Object.keys(fups).length

    return (
      <div className="hero-banner anim-scale-in">
        <div className="hero-content flex justify-between items-center wrap gap-3">
          <div>
            <div style={{ fontSize:12, opacity:0.75, marginBottom:6, letterSpacing:"0.06em", textTransform:"uppercase" }}>Selamat Datang Kembali</div>
            <div style={{ fontSize:26, fontWeight:800, marginBottom:4 }}>{currPeriod.firstname} {currPeriod.lastname}</div>
            <div style={{ opacity:0.75, fontSize:13 }}>{currPeriod.email}</div>
          </div>
          <div style={{ textAlign:"right" }}>
            <div style={{ background:"rgba(255,255,255,0.18)", backdropFilter:"blur(8px)", borderRadius:99, padding:"6px 16px", fontSize:13, fontWeight:600, marginBottom:8, display:"inline-block", border:"1px solid rgba(255,255,255,0.2)" }}>
              { isPsb ? "Instalasi" : "Tagihan Bulanan" }
            </div>
            <div style={{ fontSize:12, opacity:0.7 }}>{currPeriod.itemName}</div>
            <div style={{ fontSize:11, opacity:0.55, fontFamily:"monospace" }}>ID: {currPeriod.customerId||currPeriod.customer_id}</div>
          </div>
        </div>
        {!fupEnabled
          ? (<></>)
          : (<>
            <ProgressTrack
              min = {fups?.monthlyTotal ?? 0}
              max = {fups?.quota ?? 0}
              isDate = {false}
              isGb = {true}
              isBanner = {true}
              percentText = {"Terpakai"}
              progressText = {"Quota Tersisa"}
            />
          </>)
        }
      </div>
    )
}